<template>
  <div class="icon" :class="[iconSize, iconName]"/>
</template>

<script>
export default {
  name: "DataTableFooterIcon",
  data() {
    return {
      active: false,
    };
  },
  props: {
    size: {
      type: String,
      default: "18",
    },
    name: {
      type: String,
      default: "menu",
    },
    lightModeColour: {
      type: String,
      default: "black",
    },
    darkModeColour: {
      type: String,
      default: "white",
    },
  },
  computed: {
    iconName() {
      return this.$store.state.mode.darkMode
        ? `grunticon__icon-${this.$props.name}-${this.darkModeColour}`
        : `grunticon__icon-${this.$props.name}-${this.lightModeColour}`;
    },
    iconSize() {
      return `icon-${parseInt(this.size, 10)}`;
    },
    iconActive() {
      return this.active && this.activeEffect
        ? `grunticon__icon-${this.$props.name}-white purple rounded-sm`
        : this.iconName;
    },
  },
  methods: {
    toggleActive() {
      this.active = !this.active;
    },
  },
};
</script>

<style lang="scss" scoped>
svg {
  fill: currentColor;
}

.icon {
  height: 32px !important;
  width: 32px !important;
  padding: 4px;
  background-color: white;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid var(--apio-shade-4);
  color: var(--apio-shade-4);

  &:hover {
    border: 1px solid var(--apio-cyan);
    color: var(--apio-cyan);
  }
}

$sizes: (
  14: 14px,
  16: 16px,
  18: 18px,
  20: 20px,
  24: 24px,
  28: 28px,
  32: 32px,
  40: 40px,
  48: 48px,
  64: 64px,
  128: 128px,
  256: 256px,
);

@mixin icon-sizes {
  @each $name, $px in $sizes {
    &-#{$name} {
      height: $px;
      width: $px;
      background-size: $px;
      background-position: center;
    }
  }
}

.icon {
  @include icon-sizes;
}
</style>